const actionTypes = {
  ENQUEUE_NOTIFICATION: 'ENQUEUE_NOTIFICATION',
  DEQUEUE_NOTIFICATION: 'DEQUEUE_NOTIFICATION',
}

export default actionTypes
